import aHttp from '@/models/axiosConfig/aHttp';
import constants from '@/constants';
const {
  API_LIST: { MINIAPP_PROD, EMTCSLP_EXTERNAL_APIGATEWAY_PROD }
} = constants;

const urls = {
  getAsinDetail: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/asin/detail`, // details
  getAsinBatch: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/asin/batch`, // Commodity bulk search
  getSearchResult: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/search/getSearchResult`, // Get category list
  getAsinBatchSimple: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/asin/batchSimple`, // Obtain detailed data of a batch of products
  getSimilarities: `${MINIAPP_PROD}/search/getSimilarities`, // return asin id
  reviewAll: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/review/allV1`, // Get all comments on the current product
  reviewSample: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/review/top`, // Obtain detailed page sampling comments
  getAplusContent: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/asin/getAplusContent`, // Get aplus product details
  getBrowseInfo: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/brandStore/browseInfo` // get brand info
};

export const handleAsinBatchURLParams = (asins, encryptedMarketplaceId) => {
  let params = '';
  const asinIds = asins.map(asin => asin.asin).join(',');
  params = `ids=${encodeURIComponent(
    asinIds
  )}&marketplace=${encryptedMarketplaceId}&withCache=false&allowOtherOffer=false&returnableFlagSkipped=false`;
  return params;
};

export const getAsinDetail = params => aHttp.get(urls.getAsinDetail, params);
export const getAsinBatch = params => aHttp.get(urls.getAsinBatch, params);
export const getAsinBatchURLParams = (asins, encryptedMarketplaceId) =>
  aHttp.get(
    `${urls.getAsinBatch}?${handleAsinBatchURLParams(
      asins,
      encryptedMarketplaceId
    )}`
  );
export const getSearchResult = params =>
  aHttp.post(urls.getSearchResult, params);
export const getAsinBatchSimple = params =>
  aHttp.get(urls.getAsinBatchSimple, params);
export const getSimilarities = params =>
  aHttp.get(urls.getSimilarities, params);
export const reviewAll = params => aHttp.get(urls.reviewAll, params);
export const reviewSample = params => aHttp.get(urls.reviewSample, params);
export const getAplusContent = data => aHttp.post(urls.getAplusContent, data);
export const getBrowseInfo = params => aHttp.get(urls.getBrowseInfo, params);
